import React from 'react';
import get from 'lodash/get';
import { Descriptions } from 'antd';

const { Item } = Descriptions;

const OrderDetails = ({ orderDetailsInfo }) => {
  const gender =
    get(orderDetailsInfo, 'data.gender') === 'M' ? 'Male' : 'Female';
  return (
    <div className="product-final-confirmation-container">
      <Descriptions bordered size="small" column={1}>
        <Item label="Name">{get(orderDetailsInfo, 'data.name')}</Item>
        <Item label="Age">{get(orderDetailsInfo, 'data.age')}</Item>
        <Item label="Gender">
          {get(orderDetailsInfo, 'data.gender') ? gender : '--'}
        </Item>
        <Item label="Mobile No.">{get(orderDetailsInfo, 'data.mobile')}</Item>
      </Descriptions>
    </div>
  );
};

export default OrderDetails;
